import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./BillingPlans.css";

const BillingPlans = () => {
  const navigate = useNavigate();

  const [data, setData] = useState({
    earnings: 0,
    revenue: 0,
    costs: 0,
    usage: 0,
  });

  const [result, setResult] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: parseFloat(value) || 0 });
  };

  const calculateAll = () => {
    const profit = data.revenue - data.costs;
    const net = profit + data.earnings - data.usage;
    setResult({
      profit,
      net,
    });
  };

  const handleFreeSubscribe = () => {
    setShowModal(true);
  };

  const handleConfirm = () => {
    window.location.href = '/register';
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <div id="BillingPlans" className="billing-container">
      <h1 className="billing-title">Billing & Plans</h1>
      <p className="billing-subtitle">
        Manage your costs, track your earnings, and explore subscription plans.
      </p>

      {/* Inputs Section */}
      <div className="billing-inputs">
        <div className="input-group">
          <label>Earnings ($)</label>
          <input
            type="number"
            name="earnings"
            value={data.earnings}
            onChange={handleChange}
          />
        </div>

        <div className="input-group">
          <label>Revenue ($)</label>
          <input
            type="number"
            name="revenue"
            value={data.revenue}
            onChange={handleChange}
          />
        </div>

        <div className="input-group">
          <label>Costs ($)</label>
          <input
            type="number"
            name="costs"
            value={data.costs}
            onChange={handleChange}
          />
        </div>

        <div className="input-group">
          <label>Usage Costs ($)</label>
          <input
            type="number"
            name="usage"
            value={data.usage}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* Calculate Button */}
      <button className="calculate-btn" onClick={calculateAll}>
        Calculate Everything
      </button>

      {/* Result Section */}
      {result && (
        <div className="result-box">
          <h3>📊 Calculation Results</h3>
          <p><strong>Profit:</strong> ${result.profit}</p>
          <p><strong>Net Balance:</strong> ${result.net}</p>
        </div>
      )}

      {/* Plans Section */}
      <div className="plans-section">
        <h2>Choose Your Plan</h2>
        <div className="plans-grid">
          {/* Free Plan */}
          <div className="plan-card free pricing-card basic">
            <img
              src="https://cdn-icons-png.flaticon.com/512/6280/6280269.png"
              alt="Encouragement"
              className="encourage-img"
            />
            <h3>Gratuit</h3>
            <p className="price">0€ / mois</p>
            <ul className="centered-list">
              <li><span className="checkmark">✔</span> Accès limité aux prompts</li>
              <li><span className="checkmark">✔</span> Interface intuitive</li>
              <li><span className="cross">✖</span> Support vocal</li>
              <li><span className="cross">✖</span> Historique sauvegardé</li>
              <li><span className="checkmark">✔</span> 1,000 tokens/mois</li>
            </ul>
            <button onClick={handleFreeSubscribe}>S'inscrire</button>
          </div>

          {/* Pro Plan */}
          <div className="plan-card pro pricing-card">
            <img
              id="Pro-Plan-img"
              src="https://d1csarkz8obe9u.cloudfront.net/posterpreviews/vip-logo-design-template-098e8dfa032b844afcec2df88d1ff290_screen.jpg?ts=1738304438"
              alt="Pro VIP"
            />
            <h3>Pro</h3>
            <p className="price" style={{ color: '#ff6f00', fontSize: '2rem', marginBottom: '1rem' }}>
              €19.99/mois
            </p>
            <ul className="pro-plan-features">
              <li>Accès complet à l'IA</li>
              <li>Support vocal</li>
              <li>Historique illimité</li>
              <li>Exportation rapide</li>
              <li>Support prioritaire</li>
              <li>10,000 tokens/mois</li>
            </ul>
            <button className="try-pro-btn" onClick={() => navigate('/try-pro')}>Essayez Pro</button>
          </div>

        </div>

      </div>

      {/* Free Plan Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Bienvenue dans RapidMind AI 🎉</h3>
            <p>Votre plan gratuit inclut :</p>
            <ul className="modal-list">
              <li>✅ 10 requêtes AI par jour</li>
              <li>✅ Interface intuitive et rapide</li>
              <li>✅ Accès aux prompts essentiels</li>
              <li>✅ Thème sombre activable</li>
              <li>✅ 1,000 tokens par mois</li>
            </ul>
            <p className="small-text">C'est 100% gratuit. Vous pourrez toujours passer à un plan supérieur plus tard.</p>
            <div className="modal-actions">
              <button className="confirm" onClick={handleConfirm}>Créer mon compte gratuit</button>
              <button className="cancel" onClick={handleClose}>Annuler</button>
            </div>
          </div>
        </div>
      )}
    </div>
    
  );
};

export default BillingPlans;
